<template>
    <s-modal
        title="Mettre des timers"
        :open="open"
        @close="$emit('close')"
        @save="save(true)"
        :close="true"
        :save="true"
    >
        <s-l id="explainTimer">Vous êtes sur le point de mettre en place des timers par jeu.</s-l>
        <div>
            Timer activé :
                <s-button label="OUI" @onclick="setTimer(true)" :theme="active ? 'is-success  is-small' : 'is-primary  is-small'"
                    />
                &nbsp;
                <s-button label="NON" @onclick="setTimer(false)" :theme="!active ? 'is-success is-small' : 'is-primary  is-small'"
                   />
        </div>
        <div v-if="active && typeof(tournoi.timer)!='undefined'" style="margin-top: 10px;height: 50px">
            Délai du timer (en minutes) : <input type="number" class="input is-rounded is-primary is-small" v-model="delayTournoiPartie" style="width:150px"/> 
        </div>
        <div v-if="partie && active">
            Reinitialiser le timer pour la partie {{parseInt(partie.index)+1}}
            <div>
            <input class="input is-rounded is-primary is-small" v-model="delayPartie" style="width:150px"/>&nbsp;
            <s-button icon="arrows-rotate" @onclick="reinitTime()" label="Reinit" theme="is-warning is-small"/>
            </div>
        </div>
        <div>
        </div>
        <div v-if="!active" style="margin-top: 10px;height: 50px">
        </div>
    </s-modal>
</template>
<script>
    import firebase_api from '@/firebase/firebase_api'
    import firebase from 'firebase'
    export default ({
        props: ["tournoi", "club", "open","equipes", "firestore","partie"], 
        data() {
          return {
              delayPartie: 45,
              delayTournoiPartie: 45
          }  
        },
        computed: {
            active: {
                get() {
                    if (typeof(this.tournoi.timer)=="undefined")
                        return false;
                    else
                        return this.tournoi.timer.active;
                }
            }
        },
        mounted() {
            if (typeof(this.tournoi.timer)!="undefined") {
                this.delayPartie = this.tournoi.timer.delay;
                this.delayTournoiPartie = this.tournoi.timer.delay;
            }
        },
        methods: {
            save(close) {
                this.tournoi.timer.delay = this.delayTournoiPartie;
                firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id).update({
                    timer: this.tournoi.timer
                })
                if (close)
                    this.$emit('close')
            },
            reinitTime() {
               const functions = firebase.app().functions('europe-west1');
                    functions.httpsCallable("stamp")().then(res=>{
                        this.equipes.forEach(equipe=>{
                            var state = "pause";
                            this.firestore.equipes.doc(equipe.id).update({
                                timer: {
                                    state: state,
                                    ts: res.data.timeStamp,
                                    delay : parseInt(this.delayPartie)
                                }
                            })
                        })
                    })
            },
            setTimer(bool) {
                var prems = false;
                if (typeof(this.tournoi.timer)=="undefined") {
                    this.tournoi.timer = {
                        active: bool,
                        delay: this.delayTournoiPartie
                    }
                    prems = true;
                }
                if (this.tournoi.timer.active != bool || prems) {
                    this.tournoi.timer = {
                            active: bool,
                            delay: this.delayTournoiPartie
                    };
                    this.save();
                }
            }
        }
    })
</script>